export enum RelatedTo {
  Both = 'both',
  Main = 'main',
  Space = 'space',
}

export enum Activeness {
  Active = 'active',
  Passive = 'passive',
  Both = 'both',
}
